import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import posthog from "posthog-js";
import { applyLocaleFromUrl } from "@linqx/i18n";
import { Telemetry, TelemetryEvent } from "@linqx/telemetry";
import { router } from "@/router";
import "@/styles/app.css";

// Pick the locale from `?lang=` or the browser language before first render.
applyLocaleFromUrl();

// Wire PostHog product analytics — explicit events only (no autocapture / no
// automatic pageviews). Gated on the env key so preview/local builds without a
// key leave Telemetry a safe no-op.
const posthogKey = (
  import.meta.env.VITE_POSTHOG_KEY as string | undefined
)?.trim();
if (posthogKey) {
  posthog.init(posthogKey, {
    api_host:
      (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ??
      "https://us.i.posthog.com",
    autocapture: false,
    capture_pageview: false,
  });
  Telemetry.init(posthog, { app: "landing" });
  Telemetry.register({
    source: "landing",
    platform: "web",
    app_version: "1.0.0",
  });
  // The landing page is a single-screen marketing surface; record the view.
  Telemetry.screen("Landing");
  Telemetry.track(TelemetryEvent.APP_OPENED);
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
